<template>
    <div>
        <b-card no-body v-if="mostrarMenu">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Relatórios</span>
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-07')"
                                :href="`#/contratos/relatorios/geral`"
                                ><strong>Relatório Geral de Contratos</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-01')"
                                :href="`#/contratos/relatorios/comprometimentossemregistropagamento`"
                                ><strong
                                    >Comprometimentos sem registro de
                                    pagamento</strong
                                >
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-02')"
                                :href="`#/contratos/relatorios/relacaonotasfiscais`"
                                ><strong>Relação de Notas Fiscais</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-03')"
                                :href="`#/contratos/relatorios/comprometimentosporcontrato`"
                                ><strong>Comprometimentos por Contrato</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-04')"
                                :href="`#/contratos/relatorios/contratosporgestor`"
                                ><strong>Contratos por Gestor</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-05')"
                                :href="`#/contratos/relatorios/valorespagosporcontratos`"
                                ><strong>Valores Pagos por Contratos</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-06')"
                                :href="`#/contratos/relatorios/movimentacoesminimas`"
                                ><strong>Movimentações Mínimas</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('JUR-REL-08')"
                                :href="`#/contratos/relatorios/contratos-lai`"
                                ><strong>Relatório LAI</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('JUR-REL-09')"
                                :href="`#/contratos/relatorios/contratos-ij`"
                                ><strong>Remessa TCEPE - Modelo de Planilha de Itens do IJ</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('JUR-REL-10')"
                                :href="`#/contratos/relatorios/orcamento-e-resultados`"
                                ><strong>Remessa TCEPE - Modelo de Planilha do Orçamento e Resultados</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        mostrarMenu() {
            return this.$route.name == 'Contratos_Relatorios'
        }
    }
}
</script>
